export function assertMeasurementXYVariables(variables) {
    assertVariablesHasX(variables);
    assertVariablesHasY(variables);
}
export function assertVariablesHasX(variables) {
    if (!variables.x) {
        throw new Error('variables has not x');
    }
}
export function assertVariablesHasY(variables) {
    if (!variables.y) {
        throw new Error('variables has not y');
    }
}
export function variablesHasXY(variables) {
    return variables.x && variables.y ? true : false;
}
//# sourceMappingURL=assert.js.map